<template>
  <div
    class="vacancy-edit-progress"
    :class="isOpen ? '_open' : null"
  >
    <div class="vacancy-edit-progress__head">
      <Header
        is-mobile
        :username="(interlocutor || {}).username"
        :avatar="(interlocutor || {}).avatar"
        :online="(interlocutor || {}).online"
      />

      <div
        class="vacancy-edit-progress__btn-toggle"
        @click.prevent="isOpen = !isOpen"
      >
        <BaseSvg name="ico-arrow-light"/>
      </div>
    </div>

    <v-slide-toggle
      class="vacancy-edit-progress__toggle"
      :active="isOpen"
    >
      <div class="vacancy-edit-progress__content">
        <Chat
          is-mobile
          :user="user"
          :interactionId="interactionId"
          :stepIsReadonly="stepIsReadonly"
          :acceptPending="acceptPending"
          :isLoading="isLoading"
          @init="$emit('init', $event)"
          @changed-interlocutor="interlocutor = $event"
        />
      </div>
    </v-slide-toggle>
  </div>
</template>

<script>
  import Chat from './Chat';
  import Header from './Header';

  export default {
    components: { Chat, Header },
    props: [ 'user', 'interactionId', 'stepIsReadonly', 'acceptPending', 'isLoading' ],

    data() {
      return {
        isOpen: false,
        interlocutor: null
      };
    }
  };
</script>
